/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import {
    Button,
    Empty,
    Modal,
    Pagination,
    PaginationProps,
    Spin,
    Typography,
} from 'antd'
import './historyPage.scss'
import { HistoryDataRes } from '../../model/interface/response/history'
import { useNavigate } from 'react-router-dom'
import { PaidService } from '../../services/paid.service'
import { useNotification } from '../../components/app.toast'
import { PaymentField } from '../../model/enum/payment'
import { PaymentService } from '../../services/payment.service'
import { AxiosError } from 'axios'
import CardHistory from './components/cardHistory'

const HistoryPage: React.FC = () => {
    const navigate = useNavigate()
    const { openNotificationWithIcon, contextHolder } = useNotification()

    const [pagination, setPagination] = React.useState<{
        page: number
        pageSize: number
    }>({ page: 1, pageSize: 10 })
    const [open, setOpen] = React.useState(false)

    const onPaginationChange: PaginationProps['onChange'] = async (
        current,
        pageSize
    ) => {
        setPagination({ page: current, pageSize })
    }

    const [histories, setHistories] = React.useState<HistoryDataRes>({
        data: [],
        page: 1,
        pageSize: 10,
        total: 0,
    })
    const fetchHistories = React.useCallback(async () => {
        try {
            const resHistories = await PaidService.getHistory(
                pagination.page,
                pagination.pageSize
            )
            setHistories(resHistories)
        } catch (error) {
            console.error('Error fetching product recommendation:', error)
        }
    }, [pagination.page, pagination.pageSize])
    React.useEffect(() => {
        fetchHistories()
    }, [fetchHistories])

    const handleSelectFile = (id: string, productId: string) => {
        navigate(`/preferred-option?productId=${productId}&ref=${id}`)
    }

    const handleDownloadFile = async (id: string) => {
        try {
            const blob = await PaidService.getDownloadFile(id)

            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = 'downloadedFile.pdf'
            document.body.appendChild(a)
            a.click()
            a.remove()
            window.URL.revokeObjectURL(url)

            await fetchHistories()
        } catch (error) {
            console.log('🚀 ~ handleDownloadFile ~ error:', error)
        }
    }

    const handleDeleteHistory = (id: string) => {
        try {
            Modal.confirm({
                title: 'คุณต้องการลบประวัติการชำระเงินหรือไม่',
                okText: 'ตกลง',
                okType: 'danger',
                cancelText: 'ยกเลิก',
                onOk: async () => {
                    try {
                        await PaidService.deletedHistory(id)
                        if ((histories.total - 1) % histories.pageSize == 0)
                            setPagination((prev) => {
                                return {
                                    page: prev.page === 1 ? 1 : prev.page - 1,
                                    pageSize: prev.pageSize,
                                }
                            })
                        fetchHistories()
                        openNotificationWithIcon(
                            'success',
                            'success_delete_history'
                        )
                    } catch (error) {
                        openNotificationWithIcon(
                            'error',
                            'success_delete_history'
                        )
                    }
                },
                centered: true,
            })
        } catch (errorInfo) {
            console.log('Delete Failed:', errorInfo)
        }
    }

    const handleReUpload = (id: string, productId: string) => {
        navigate(`/order/${productId}?refId=${id}`)
    }

    const handleCancelPayment = (id: string) => {
        try {
            Modal.confirm({
                title: 'คุณต้องการยกเลิกการชำระเงินหรือไม่',
                okText: 'ตกลง',
                okType: 'danger',
                cancelText: 'ยกเลิก',
                onOk: async () => {
                    try {
                        await PaidService.patchDeletedHistory(id)
                        if ((histories.total - 1) % histories.pageSize == 0) {
                            setPagination((prev) => {
                                return {
                                    page: prev.page === 1 ? 1 : prev.page - 1,
                                    pageSize: prev.pageSize,
                                }
                            })
                        }
                        fetchHistories()
                    } catch (error) {
                        openNotificationWithIcon(
                            'error',
                            'success_cancel_payment'
                        )
                    }
                },
                centered: true,
            })
        } catch (errorInfo) {
            console.log('Delete Failed:', errorInfo)
        }
    }
    const handleVerify = async (
        id: string,
        amount: number,
        slipUrl: string
    ) => {
        setOpen(true)
        try {
            await PaymentService.postPaymentVerify({
                [PaymentField.PAYMENT_URL]: slipUrl,
                [PaymentField.PAYMENT_AMOUNT]: amount,
                [PaymentField.PAYMENT_ID]: id,
            })
        } catch (error) {
            const axiosError = error as AxiosError
            openNotificationWithIcon(
                'error',
                `ไม่สามารถตรวจสอบการชำระเงินได้: ${axiosError?.message} กรุณาลองใหม่อีกครั้ง หรือติดต่อแอดมิน`
            )
        }
        setOpen(false)
        fetchHistories()
    }

    return (
        <div className="history">
            {contextHolder}

            <Typography.Title level={2}>ประวัติการซื้อ</Typography.Title>

            <div className="lists-history">
                {histories?.data.length === 0 ? (
                    <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description="ไม่มีข้อมูล"
                    />
                ) : (
                    histories?.data.map((item) => (
                        // <div key={item.id} className="card-history">
                        //     <div className="detail">
                        //         <Image
                        //             src={item.banner}
                        //             alt={'image' + item.banner}
                        //         />
                        //         <div className="text">
                        //             <Typography.Paragraph
                        //                 ellipsis={{ rows: 2 }}
                        //                 style={{ margin: 0 }}
                        //             >
                        //                 {item.productName}
                        //             </Typography.Paragraph>
                        //             <Typography.Paragraph
                        //                 className="price"
                        //                 style={{ color: ColorsConstant.info }}
                        //             >
                        //                 {item.price.toLocaleString()} บาท
                        //             </Typography.Paragraph>
                        //             <StatusList
                        //                 status={item.status}
                        //                 selected={item.selected}
                        //                 downloaded={item.downloaded}
                        //                 errorMessage={item.slipOKRes.message}
                        //                 slip={item.slip}
                        //             />
                        //             <CountdownTimer
                        //                 expiryDate={item.uploadSlipDate.toLocaleString()}
                        //             />
                        //         </div>
                        //     </div>

                        //     <div className="button-container">
                        //         {item.status === Status.VERIFYING && (
                        //             <Button type="primary" disabled>
                        //                 อัพโหลดหลักฐานการโอนเงิน
                        //             </Button>
                        //         )}
                        //         {item.status === Status.FAILED && (
                        //             <Button
                        //                 type="primary"
                        //                 onClick={() =>
                        //                     handleReUpload(
                        //                         item.id,
                        //                         item.productId
                        //                     )
                        //                 }
                        //             >
                        //                 อัพโหลดหลักฐานการโอนเงิน
                        //             </Button>
                        //         )}
                        //         {item.status === Status.WAITING_VERIFY && (
                        //             <Button
                        //                 type="primary"
                        //                 onClick={() =>
                        //                     handleVerify(
                        //                         item.id,
                        //                         item.price,
                        //                         item.slip.url
                        //                     )
                        //                 }
                        //             >
                        //                 ตรวจสอบการโอนเงิน
                        //             </Button>
                        //         )}
                        //         {item.status === Status.VERIFIED ? (
                        //             <>
                        //                 {!item.selected ? (
                        //                     <Button
                        //                         type="primary"
                        //                         onClick={() =>
                        //                             handleSelectFile(
                        //                                 item.id,
                        //                                 item.productId
                        //                             )
                        //                         }
                        //                     >
                        //                         เลือกไฟล์
                        //                     </Button>
                        //                 ) : (
                        //                     <Button
                        //                         type="primary"
                        //                         disabled={item.downloaded}
                        //                         onClick={() =>
                        //                             handleDownloadFile(item.id)
                        //                         }
                        //                     >
                        //                         ดาวน์โหลดไฟล์
                        //                     </Button>
                        //                 )}
                        //                 <Button
                        //                     danger
                        //                     disabled={!item.downloaded}
                        //                     onClick={() =>
                        //                         handleDeleteHistory(item.id)
                        //                     }
                        //                 >
                        //                     ลบประวัติ
                        //                 </Button>
                        //             </>
                        //         ) : (
                        //             <Button
                        //                 danger
                        //                 disabled={
                        //                     item.status === Status.VERIFYING
                        //                 }
                        //                 onClick={() =>
                        //                     handleCancelPayment(item.id)
                        //                 }
                        //             >
                        //                 ยกเลิกธุรกรรม
                        //             </Button>
                        //         )}
                        //     </div>
                        // </div>
                        <CardHistory
                            key={item.id}
                            item={item}
                            handleSelectFile={handleSelectFile}
                            handleDownloadFile={handleDownloadFile}
                            handleDeleteHistory={handleDeleteHistory}
                            handleReUpload={handleReUpload}
                            handleCancelPayment={handleCancelPayment}
                            handleVerify={handleVerify}
                        />
                    ))
                )}
                <div className="pagination">
                    <Pagination
                        current={histories.page}
                        pageSize={histories.pageSize}
                        total={histories.total}
                        onChange={onPaginationChange}
                        showSizeChanger
                    />
                </div>
            </div>
            <Modal
                open={open}
                closeIcon={false}
                footer={[
                    <Button
                        key="back"
                        type="primary"
                        onClick={() => setOpen(false)}
                    >
                        ยกเลิกการตรวจสอบ
                    </Button>,
                ]}
                className="modal_card"
                centered
                maskClosable={false}
            >
                <Typography.Title style={{ color: 'gray' }}>
                    กรุณารอสักครู่ ....
                </Typography.Title>
                <Spin size="large" />
                <span>ระบบกำลังตรวจสอบรายการการชำระเงินของท่าน</span>
            </Modal>
        </div>
    )
}
export default HistoryPage
